import { apiFailureErrorMessage, HttpService } from '../utils/httpService';
import { ENDPOINTS } from '../config/endpoints/stage';

export class SessionService {
	constructor(private httpService: HttpService) {}

	async fetchMeetingLink(roomId: string, userId: string, userType: number) {
		const url = `${ENDPOINTS.ROOT}/session/joinMeeting/${roomId}/${userId}/${userType}`;
		try {
			const response = await this.httpService.get<any>(url);
			return response.data;
		} catch (error) {
			throw new Error(apiFailureErrorMessage);
		}
	}

	async fetchZoomVideoSDKSignature(roomId: string, userId: string, userType: number,body:any) {
        const url = `${ENDPOINTS.ROOT}/session/joinMeeting/${roomId}/${userId}/${userType}`;
        try {
            const response = await this.httpService.post<any>(url, {
                data: body,
            });
            return response.data;
        } catch (error) {
            throw new Error(apiFailureErrorMessage);
        }
    }

	async fetchUpcomingSessions(userID: string, userType: string) {
		const url = `${ENDPOINTS.ROOT}/session/get/${userID}/${userType}`;
		// const fetchFeedbackUrl = `${ENDPOINTS.ROOT}/session/feedback/get/${userID}/${userType}`
		// const fetchVideosUrl = `${ENDPOINTS.ROOT}/session/videos/${userType}/${userID}`
		try {
			const { data } = await this.httpService.get<any>(url);
			console.log('fetch upcoming session', data);
			// const feedback = await this.httpService.get<any>(fetchFeedbackUrl)
			// const videos = await this.httpService.get<any>(fetchVideosUrl)
			// return {
			// 	sessionData: session.data.sessionData,
			// 	feedbackData: session.data.feedbackData,
			// 	videoData: session.data.videoData,
			// 	scoreData: session.data.scoreData,
			// };
			return data;
		} catch (error) {
			throw new Error(apiFailureErrorMessage);
		}
	}

	async getSessionWithoutFeedback(userID: string) {
		const url = `${ENDPOINTS.ROOT}/session/feedback/${userID}`;
		try {
			const { data } = await this.httpService.get<any>(url);
			// console.log(data)
			return data.session;
		} catch (err) {
			console.log(err);
			throw err;
		}
	}

	async postFeedback(sessionId: string, userType: string, body: any) {
		const url = `${ENDPOINTS.ROOT}/session/add/feedback/${sessionId}`;
		try {
			const postData: any = { userType, feedback: body };
			console.log(postData);
			const { data } = await this.httpService.post<any>(url, {
				data: postData,
			});
			console.log(data);
			return data;
		} catch (err) {
			console.log(err);
			throw err;
		}
	}
}
